<template>
  <div class="w-full relative my-24 ">
    <h2
      class="text-3xl font-semibold text-center mb-16 text-gray-900 px-4 sm:px-6 md:px-8 lg:px-40"
    >
      {{ title }}
    </h2>
    <cardCarousel :cards="cards" />
  </div>
</template>

<script>
const cardCarousel = () =>
  import(/* webpackChunkName: "cardCarousel" */ "../cardCarousel.vue");

export default {
  components: {
    cardCarousel,
  },
  data() {
    return {
      title: "Trusted by businesses like yours",
      cards: [
        {
          name: "Bill Lapcevic",
          position: "VP Business Development at Auth0",
          text: `"The addition of Youverse to Auth0 Marketplace adds greater breadth to our platform and gives customers even more extensibility and flexibility when designing the identity platform of their dreams."`,
        },
        {
          name: "João Freitas",
          position: "Director of Growth & Partnerships at Host Hotel Systems",
          text: `"Digitization is a priority in Host Hotel Systems’ mission and partnering with Youverse for check-in automation brings our clients closer to our vision of a seamless guest experience."`,
        },
        {
          name: "Jurgen Neutgens",
          position: "Board of Directors at Volksbank Koln Bonn eG",
          text: `"The intuitive operation of the VR kiosk leads to the fact that our customers diligently test the range of functions and successfully buy products. As a digital partner (...) it is a matter of course for us to try out and promote this."`,
        },

        {
          name: "Floor Bleeker",
          position: "Group CTO at Accor",
          text: `"When Youverse pitched and won the Accor Middle East & Africa startup contest in 2020, it became clear to me that their technology had the potential to bring a true frictionless experience to the hospitality industry."`,
        },
        {
          name: "Josef Schneider",
          position: "Managing Director at Pyramid Computer GmbH",
          text: `"Partnering with Youverse makes it extremely easy to integrate face authentication and identity verification into our kiosk solutions and bring them to well-known customers such as VR Bank."`,
        },
        {
          name: "Philipp Losbichler",
          position: "CTO at Agravity Gmbh",
          text: `"I got to know Youverse from the VR eKiosk project where we make a full validation of the extracted identity photo with the face of the person standing in front of the kiosk. Their software Youverse Face™ is fast, reliable and easy to use. We are very happy to have them on board."`,
        },
        {
          name: "Juan Sebastian Vargas",
          position: "Product Manager at Become Digital",
          text: `"With Youverse we went live in a couple of hours. There is no doubt one of their strengths is frictionless integration."`,
        },
      ],
    };
  },
};
</script>